import { render, staticRenderFns } from "./BuildSummaryCard.vue?vue&type=template&id=9c274a9c&scoped=true"
import script from "./BuildSummaryCard.vue?vue&type=script&lang=js"
export * from "./BuildSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./BuildSummaryCard.vue?vue&type=style&index=0&id=9c274a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c274a9c",
  null
  
)

export default component.exports